import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'

export const useAppBarComponentStyles = makeStyles((theme: Theme) => ({
  appBar: {
    backgroundColor: theme.palette.primary.main,
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarAdmin: {
    background: `linear-gradient(
    180deg, 
    ${theme.palette.secondary.main} 10%, 
    ${theme.palette.primary.main} 10%, 
    ${theme.palette.primary.main} 100%
    )`,
  },
  appBarWhenDrawerSmall: {
    width: `calc(100% - ${(theme.custom?.drawerWidthSmall || 0)}px)`,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarWhenDrawerLarge: {
    width: `calc(100% - ${theme.custom?.drawerWidthLarge || 0}px)`,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  appBarToolbar: {
    display: 'flex',
    justifyContent: 'flex-end',
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  appBarSpacer: theme.mixins.toolbar,
}))
